'use strict';

/**
 * Service: Filters
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export wdFilterService for ES6 usage
 *          5.7.2 #388 Extend 'wdFilterService'
 *          5.3.0 #304 Add Class to Filter Service Button Group
 *          5.3.0 #303 Remove Redundant Code
 *          5.0.1 #286 Standardise Data Loading and Parsing Services
 *          5.0.1 #278 Re-factor for Dashboard
 *          3.3.0 #275 Build & Improve Filters Directive
 *          3.2.0 #261 Unit Test Coverage, Tidy
 *          3.0.0 #236 Add Shared Functionality to Main Library
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 *
 * @copyright (c) 2015-2020 Build Centrix
 */
var wdFilterService = angular.module('wd.custom.filters', [])
    .factory(
    'wdFilterService',
    function ()
    {

        // Service Object
        var service = {};

        // Filters
        service.filtering = {
            columns:        {},
            pageSize:       {},
            search:         {},
            data:           { filters: [] },
            buttons:        [],
            buttonGroup:    { buttons:[] },
            options:        {},
            primaryButtons: [],
            dropdown:       {}
        };

        /**
         * Add Custom Dropdown Filter for Display
         *
         * @since 3.3.0
         * @param title
         * @param className
         * @param icon
         * @param description
         * @param updateFunction
         * @returns {boolean}
         */
        service.addButton = function(title, className, icon, description, updateFunction){

            var result = true;

            service.filtering.buttons.push({

                show: true,
                icon: icon,
                className: className,
                title: title,
                description: description,
                update: function(response) { updateFunction(response); }

            });

            return result;

        };

        /**
         * Add Custom Dropdown Filter for Display
         *
         * @since 3.3.0
         * @param title
         * @param className
         * @param icon
         * @param description
         * @param updateFunction
         * @returns {boolean}
         */
        service.addPrimaryButton = function(title, className, icon, description, updateFunction){

            var result = true;

            service.filtering.primaryButtons.push({

                show: true,
                icon: icon,
                className: className,
                title: title,
                description: description,
                update: function(response) { updateFunction(response); }

            });

            return result;

        };

        /**
         * Add button to Button Group
         *
         * @since 3.3.0
         * @param title
         * @param className
         * @param icon
         * @param description
         * @param updateFunction
         * @returns {boolean}
         */
        service.addToButtonGroup = function(title, className, icon, description, updateFunction){

            var result = true;

            service.filtering.buttonGroup.show = true;
            service.filtering.buttonGroup.buttons.push({

                icon: icon,
                className: className,
                title: title,
                description: description,
                update: function(response) { updateFunction(response); }

            });

            return result;

        };

        /**
         * Add Column Filter for Display
         *
         * @since 3.0.0
         * @returns {boolean}
         */
        service.addColumnFilter = function(columns, updateFunction){

            var result = true;

            service.filtering.columns = {

                show: true,
                source: columns,
                update: function() { updateFunction(); },
                reset: function() {
                    service.resetFiltering(service.filtering.columns.source);
                }

            };

            return result;

        };

        /**
         * Add Multiple Column Filters for Display
         *
         * @since 5.7.2
         * @returns {boolean}
         */
        service.addToColumnFilter = function(key, columns, updateFunction){

            var result = true;

            service.filtering.columns[key] = {
                show: true,
                source: columns,
                update: function () {
                    updateFunction();
                },
                reset: function () {
                    service.resetFiltering(service.filtering.columns[key].source);
                }
            };

            return result;

        };
        
        /**
         * Add Custom Data Filter for Display
         *
         * @since 3.0.0
         * @returns {boolean}
         */
        service.addDataFilter = function(title, data, updateFunction){

            var result = true;

            service.filtering.data = {

                show: true,
                source: data,
                title: title,
                update: function(response) { updateFunction(response); },
                reset: function() {
                    service.resetFiltering(service.filtering.data.source);
                }

            };

            return result;

        };

        /**
         * Add Custom Data Filter for Display
         *
         * @since 3.0.0
         * @returns {boolean}
         */
        service.addToDataFilter = function(title, data, updateFunction){

            var result = true;

            service.filtering.data.show = true;
            service.filtering.data.filters.push({source: data, title: title});
            service.filtering.data.update = function(response) { updateFunction(response); };
            service.filtering.data.reset = function() {
                for(var i = 0; i<service.filtering.data.filters.length; i++) {
                    service.resetFiltering(service.filtering.data.filters[i].source);
                }
            };

            return result;

        };

        /**
         * Add Options
         *
         * @since 3.0.0
         * @returns {boolean}
         */
        service.addDropdownFilter = function(title, links, updateFunction){

            var result = true;

            service.filtering.dropdown[title] = {

                show: true,
                source: links,
                title: title,
                update: function(response) { updateFunction(response); }

            };

            return result;

        };

        /**
         * Add Page Size Option for Display
         *
         * @since 3.0.0
         * @returns {boolean}
         */
        service.addPageSizeFilter = function(possibleSizes, defaultSize, updateFunction){

            var result = true;

            service.filtering.pageSize = {

                show: true,
                source: possibleSizes,
                value: defaultSize,
                update: function() { updateFunction(service.filtering.pageSize.value); }

            };

            return result;

        };

        /**
         * Add Search Filter for Display
         *
         * @since 3.0.0
         * @param updateFunction
         * @param initialSearch
         * @param placeholder
         * @returns {boolean}
         */
        service.addSearchFilter = function(updateFunction, initialSearch, placeholder){

            var result = true;
            service.filtering.search = {

                show: true,
                value: initialSearch,
                placeholder: placeholder,
                update: function() { updateFunction(); },
                reset: function() { service.filtering.search.value = ''; updateFunction(); }

            };
            return result;

        };

        /**
         * Removes all Filtering from Display
         *
         * @since 3.0.0
         * @returns {boolean}
         */
        service.removeAllFilters = function(){

            var result = true;

            service.filtering = {
                columns:        { show: false },
                pageSize:       { show: false },
                search:         { show: false },
                data:           { show: false, filters: [] },
                buttons:        [],
                buttonGroup:    { show: false, buttons: [] },
                options:        { },
                primaryButtons: [],
                dropdown:       { show: false }
            };

            return result;

        };

        /**
         * Reset Filters on a Scope target
         *
         * @since 3.0.0
         * @param target
         */
        service.resetFiltering = function (target)
        {

            var result = [];

            for (var item in target) {

                /* istanbul ignore else */
                if (target.hasOwnProperty(item)) {

                    target[item].selected = true;
                    result.push(target[item]);

                }

            }

            return result;

        };

        return service;

    }
);
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdFilterService;
}
// EOF
